import React from 'react';
import { Typography } from '../../../../../wag-react/components/Typography';
import { Box, BoxProps } from '../../../../../wag-react/next-components/box';
import { Image } from '../../../../../wag-react/next-components/image';
import CheckmarkIcon from '../assets/checkmark.svg';
import { formatSpecialtySlug } from '../helpers/formatSpecialtySlug';
type Props = {
  label: string;
  containerProps?: BoxProps;
};
export const WalkerSpecialty = ({
  label,
  containerProps = {}
}: Props) => <Box display="flex" alignItems="center" {...containerProps} data-sentry-element="Box" data-sentry-component="WalkerSpecialty" data-sentry-source-file="WalkerSpecialties.tsx">
    <Image src={CheckmarkIcon} width={['16px', '18px']} height={['16px', '18px']} mr={[1, 2]} alt={label} data-sentry-element="Image" data-sentry-source-file="WalkerSpecialties.tsx" />
    <Typography color="#272727" variant="body2" fontFamily="muli" m={0} fontSize="14px" data-sentry-element="Typography" data-sentry-source-file="WalkerSpecialties.tsx">
      {formatSpecialtySlug(label)}
    </Typography>
  </Box>;